// extracted by mini-css-extract-plugin
module.exports = {"langselector":"UPxvp","langbtn":"jBhks","active":"JyyRY","langdropdown":"qORtK"};